import { render, staticRenderFns } from "./FormLogin.vue?vue&type=template&id=60b4e1cf&"
import script from "./FormLogin.vue?vue&type=script&lang=js&"
export * from "./FormLogin.vue?vue&type=script&lang=js&"
import style0 from "./FormLogin.vue?vue&type=style&index=0&id=60b4e1cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports